<template>
  <div class="custom-table-header">
    <Skeleton height="26px" width="540px" borderRadius="4px" />
  </div>
  <div class="custom-table">
    <div class="custom-table-row custom-table-row--head">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--head"
      >
        <Skeleton height="18px" width="117px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--body">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>

    <div class="custom-table-row custom-table-row--last">
      <div
        class="custom-table-cell custom-table-cell--c1 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c2 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c3 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c4 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c5 custom-table-cell--body"
      >
        <Skeleton height="18px" width="90px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c6 custom-table-cell--body"
      >
        <Skeleton height="18px" width="146px" borderRadius="4px" />
      </div>
      <div
        class="custom-table-cell custom-table-cell--c7 custom-table-cell--body"
      >
        <Skeleton height="18px" width="67px" borderRadius="4px" />
      </div>
    </div>
  </div>
  <div class="custom-table-footer">
    <div class="custom-table-footer-left">
      <Skeleton height="32px" width="32px" borderRadius="4px" />
      <Skeleton height="32px" width="32px" borderRadius="4px" />
      <Skeleton height="32px" width="176px" borderRadius="4px" />
      <Skeleton height="32px" width="32px" borderRadius="4px" />
      <Skeleton height="32px" width="32px" borderRadius="4px" />
    </div>
    <div class="custom-table-footer-right">
      <Skeleton height="42px" width="173px" borderRadius="4px" />
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

%row-base {
  display: flex;
  align-items: center;
  background: $colorN00;
}

%cell-base {
  display: flex;
  align-items: center;
  align-self: stretch;
}

@mixin head-cell($w, $hasBorder: true) {
  @extend %cell-base;
  width: $w;
  height: 50px;
  padding: 14px 8px 14px 12px;
  gap: 2px;
  @if $hasBorder {
    border-right: 0.5px solid $colorN30;
  }
}

@mixin body-cell($w, $pad, $gap: null) {
  @extend %cell-base;
  width: $w;
  padding: $pad;
  @if $gap != null {
    gap: $gap;
  }
  border-right: 0.5px solid $colorN50;
}

.custom-table-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  padding-top: 4px;
  padding-bottom: 12px;
}

.custom-table {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid $colorN50;
}

/* Rows */
.custom-table-row--head {
  @extend %row-base;
  align-self: stretch;
  border-radius: 8px 8px 0 0;
  border-bottom: 2px solid $colorN50;
}

.custom-table-row--body {
  @extend %row-base;
  height: 60px;
  border-bottom: 1px solid $colorN50;
}

.custom-table-row--last {
  @extend %row-base;
  height: 60px;
  border-radius: 0 0 8px 8px;
  border: 0 solid $colorN50;
}

$head-widths: (
  1: 140px,
  2: 140px,
  3: 140px,
  4: 170px,
  5: 140px,
  6: 170px,
);

@each $i, $w in $head-widths {
  .custom-table-cell--c#{$i}.custom-table-cell--head {
    @include head-cell($w);
  }
}

.custom-table-cell--c7.custom-table-cell--head {
  @extend %cell-base;
  height: 50px;
  padding: 14px 8px 14px 12px;
  gap: 2px;
  flex: 1 0 0;
  border-right: 0.5px solid $colorN30;
}

$body-cells: (
  1: (
    w: 140px,
    pad: 16px 12px,
  ),
  2: (
    w: 140px,
    pad: 16px 12px,
  ),
  3: (
    w: 140px,
    pad: 16px 12px,
  ),
  4: (
    w: 170px,
    pad: 12px,
  ),
  5: (
    w: 140px,
    pad: 12px 8px,
    gap: 10px,
  ),
  6: (
    w: 170px,
    pad: 12px,
  ),
  7: (
    w: 146px,
    pad: 16px 12px,
  ),
);

@each $i, $cfg in $body-cells {
  .custom-table-cell--c#{$i}.custom-table-cell--body {
    @include body-cell(
      map-get($cfg, w),
      map-get($cfg, pad),
      map-get($cfg, gap)
    );
  }
}

.custom-table-footer {
  display: flex;
  height: 42px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  &-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
